import { MODE } from '../../builder/bulder-datas';

export class BuilderData {

	public currentDrawing: string = MODE.DRAG;

	constructor () {
		this.currentDrawing = MODE.DRAG;
	}
}


